import React from 'react';
import PropTypes from 'prop-types';
import {TransitionGroup, CSSTransition} from 'react-transition-group';

import '../css/animations.css';

const Financials = props => (
  <div className="financials">
      <h2><span className="financials__label">Spent</span>
        <div className="financials__value">
          $
          <TransitionGroup component="span" className="salary-spent">
            <CSSTransition classNames="salary-spent" key={props.spent} timeout={{enter: 500, exit: 500}}>
              <span>{props.spent}</span>
            </CSSTransition>
          </TransitionGroup>
          m
        </div>
      </h2>
      <h2><span className="financials__label">Remaining</span>
        <div className="financials__value">
          $
          <TransitionGroup component="span" className="salary-remaining">
            <CSSTransition classNames="salary-remaining" key={props.remaining} timeout={{enter: 500, exit: 500}}>
              <span>{props.remaining}</span>
            </CSSTransition>
          </TransitionGroup>
          m
        </div>
      </h2>

  </div>
)

Financials.propTypes = {
  spent: PropTypes.number,
  remaining: PropTypes.number,
}

export default Financials;